import React from 'react';
import PropTypes from 'prop-types';

const ToggleButton = ({collapseMenuId}) => {
    return(
        <div className="col-xs-2 collapse-btn visible-xs">
            <button 
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target={`#${collapseMenuId}`}
                aria-expanded="false">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"/>
                <span className="icon-bar"/>
                <span className="icon-bar"/>
            </button>
        </div>
    );
};

ToggleButton.propTypes = {
    collapseMenuId: PropTypes.string.isRequired,
};

export default ToggleButton;


// WEBPACK FOOTER //
// ./src/components/TopMenu/ToggleButton.js